module.exports = __webpack_public_path__ + "static/img/阴天.dfb34965.svg";